import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from "firebase/firestore";

export const firebaseConfig = {
  apiKey: "AIzaSyAyvwFkpHc2XStRZxX1Vh9_nxt90B7MBL8",
  authDomain: "teachers-time-track.firebaseapp.com",
  projectId: "teachers-time-track",
  storageBucket: "teachers-time-track.firebasestorage.app",
  messagingSenderId: "417613994165",
  appId: "1:417613994165:web:c60d367a6693f3cd5d46fc",
  measurementId: "G-MXZL4QT36X"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});
